<template>
    <div class="main-container">
        <!-- <router-view></router-view> -->
        <cb-web/>
        <div
            v-show="isScrollTop"
            class="arrow"
            v-scroll-to="item.path"
        >
            <div class="arrow_box">
                <div class="arrow_box_line arrow_line_left"></div>
                <div class="arrow_box_line arrow_line_right"></div>
            </div>
        </div>
        <div class="main-content">
            <div class="spacer">
                <div class="slogan">
                    <p>with open(web) as visitors:</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;
                        for you in visitors:</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        if all(trait in ["imagination", "diligence", "dream"] for trait in you):</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        return 'We are looking for you'</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        else:</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        return 'Welcome CloudyBay'</p>
                </div>
            </div>
            <div class="sub-content">
                <supports id="support"/>
                <products id="products"/>
                <about id="about"/>
                <app-footer id="footer"/>
            </div>
        </div>
    </div>
</template>

<script>
    import CBWeb from '@/components/CBWeb.vue'
    import Menu from '@/components/Menu.vue'
    import Support from '@/components/Support.vue'
    import Products from '@/components/Products.vue'
    import About from '@/components/About.vue'
    import Footer from '@/components/footer.vue'

    export default {
        name: 'Main',
        components: {
            'cb-web': CBWeb,
            'app-menu': Menu,
            'supports': Support,
            'products': Products,
            'about': About,
            'app-footer': Footer
        },
        data() {
            return {
                item: {
                    path: '#support'
                },
                isScrollTop: true
            }
        },
        methods: {
            scroll() {
                this.isScrollTop = window.scrollY === 0 ? true : false
            }
        },
        mounted() {
            window.addEventListener('scroll', this.scroll)
        }
        // methods: {
        //     page_scroll: function () {
        //         window.scrollTo(0, window.innerHeight)
        //     }
        // }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import '../assets/css/cb.scss';
    @import "../assets/font_icon/style.css";
</style>
